import { render } from "./AdminViewPayment.vue?vue&type=template&id=7b8593dc"
import script from "./AdminViewPayment.vue?vue&type=script&lang=js"
export * from "./AdminViewPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__